

import axios from "axios";

export const apicall = {
    data() {
        return {
            data: {},
        };
    },
    methods: {
        async apicall(
            endpoint,
            method_param
        ) {
            var config = {
                method: "POST",
                url: `https://sn3ezxtgcc.execute-api.us-east-1.amazonaws.com/dev/${endpoint}`,
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": "EgnUv9Owyt8KacFkfnB44as9uqCT8ZaF9FZ1cVU6",

                },
                data: method_param,
            };
            try {
                let res = await axios(config);
                return res;
            } catch (error) {
                console.log(error);
            }
        },
    },
};
